import {
  ApiResponse,
  PaginationProps,
  PaginationResponse,
} from '../../../../constants/types';
import { AssignmentType } from '../../../../constants/types/lms/type';
import {
  VoucherItem,
  VoucherHistoryItem,
  VoucherProductItem,
  VoucherHistoryStudentItem,
  VoucherHistoryInfo,
} from '../../../../constants/types/lms/voucher/type';
import instance from '../../../axios/utils.ts/instance';

interface VoucherListParams {
  classId: string;
  courseId: string;
}

/**
 * LMS > 이용권 관리 : 이용권 목록 조회
 * @param classId
 * @param courseId
 * @returns
 */
export const getVoucherList = async (params: VoucherListParams) => {
  const { classId, ...rest } = params;

  const result = await instance.get<ApiResponse<VoucherItem[]>>(
    `/v1/lms/${classId}/todo/voucher`,
    {
      params: rest,
    },
  );
  return result.data.data;
};

interface VoucherHistoryListParams {
  classId: string;
  type: AssignmentType;
  page: number;
  pageSize: number;
  filter?: 'charge' | 'use';
  fromDate?: string;
  toDate?: string;
}

/**
 * LMS > 이용권 관리 : 이용권 적립/사용 내역 조회
 * @param classId
 * @param type
 * @param page
 * @param pageSize
 * @param filter
 * @param fromDate
 * @param toDate
 * @returns
 */
export const getVoucherHistoryList = async (
  params: VoucherHistoryListParams,
) => {
  const { classId, ...rest } = params;

  const result = await instance.get<
    ApiResponse<
      PaginationResponse<VoucherHistoryItem[]> & {
        remaining: number;
        totalCharged: number;
        totalUsed: number;
      }
    >
  >(`/v1/lms/${classId}/jebson/voucher-history`, { params: rest });
  return result.data.data;
};

/**
 * LMS > 이용권 관리 : 이용권 상품 목록 조회
 * @returns
 */
export const getVoucherProductList = async () => {
  const result = await instance.get<
    ApiResponse<{ items: VoucherProductItem[] }>
  >(`/v1/lms/todo/voucher-products`);
  return result.data.data;
};

interface VoucherHistoryStudentListParams {
  classId: string;
  txId: number;
  page: number;
  pageSize: number;
  name?: string;
  uid?: string;
}

/**
 * LMS > 이용권 관리 : 이용권 내역 상세
 * @param classId
 * @param txId
 * @param page
 * @param pageSize
 * @param name
 * @param uid
 * @returns
 */
export const getVoucherHistoryStudentList = async (
  params: VoucherHistoryStudentListParams,
) => {
  const { classId, txId, ...rest } = params;

  const result = await instance.get<
    ApiResponse<
      VoucherHistoryInfo & {
        students: VoucherHistoryStudentItem[];
        page: PaginationProps;
      }
    >
  >(`/v1/lms/${classId}/jebson/voucher-history/${txId}/students`, {
    params: rest,
  });
  return result.data.data;
};
